'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Modal = require('../../Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Row = require('../../Grid/Row/Row');

var _Row2 = _interopRequireDefault(_Row);

var _Column = require('../../Grid/Column/Column');

var _Column2 = _interopRequireDefault(_Column);

var _Uploader = require('../../Uploader/Uploader');

var _Uploader2 = _interopRequireDefault(_Uploader);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Components


var Uploader = function Uploader(_ref) {
  var visible = _ref.visible,
      children = _ref.children,
      onClose = _ref.onClose,
      uploading = _ref.uploading,
      onUpload = _ref.onUpload;
  return _react2.default.createElement(_Modal2.default, {
    title: 'File Upload',
    icon: 'upload',
    visible: visible,
    onClose: onClose,
    size: !!children ? 'large' : 'medium'
  }, function (Content) {
    return _react2.default.createElement(Content, null, _react2.default.createElement(_Row2.default, null, !!children && _react2.default.createElement(_Column2.default, {
      size: 1 / 2
    }, children), _react2.default.createElement(_Column2.default, {
      size: !!children ? 1 / 2 : 1
    }, _react2.default.createElement(_Uploader2.default, {
      loading: uploading,
      onChange: onUpload
    }))));
  });
};

Uploader.propTypes = {
  visible: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  uploading: _propTypes2.default.bool,
  onUpload: _propTypes2.default.func,
  children: _propTypes2.default.node
};
exports.default = Uploader;